import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import YouTube from "react-youtube";

function Player({ 
    track,
    isPlaying,
    setIsPlaying,
    duration,
    setDuration,
    currentTime,
    playerRef,
    progressBarRef,
    options,
    readyPlayer,
    handleStateChange,
    calculateTime,
    play,
    togglePlayPause,
    stop,
    changeRange,
    backTen,
    forwardTen,
    timeTravel }) {

    return (
        <div>
            <YouTube videoId={track} opts={options} onReady={readyPlayer} onStateChange={handleStateChange} className="video" />

            <div className="player">
                {/* player controls */}
                <button className="controls" onClick={backTen}>
                    <FontAwesomeIcon
                        icon="fa-solid fa-backward"
                        className="icon"
                    />
                </button>
                <button className="controls" onClick={togglePlayPause}>
                    {isPlaying ? 
                        <FontAwesomeIcon
                            icon="fa-solid fa-pause"
                            className="icon"
                        /> 
                    : 
                        <FontAwesomeIcon
                            icon="fa-solid fa-play"
                            className="icon"
                        />
                    }
                </button>
                <button className="controls" onClick={forwardTen}>
                    <FontAwesomeIcon
                        icon="fa-solid fa-forward"
                        className="icon"
                    />
                </button>
    
                {/* current time */}
                <div className="time">{calculateTime(currentTime)}</div>
    
                {/* progress bar */}
                <div className="progressBarWrapper">
                    <input type="range" className="progressBar" defaultValue="0" ref={progressBarRef} onChange={changeRange} />
                </div>
    
                {/* duration */}
                <div className="time">{duration && calculateTime(duration)}</div>
            </div>

        </div>
    );
}

export default Player;